
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { Document, User } from "@/generated/graphql";
  import Roles from "@/entities/Roles";
  import ManagementDocumentInfoProvider from "@/components/documents/ManagementDocumentInfoProvider.vue";
  import RemoveDocumentModal from "@/components/documents/RemoveDocumentModalNew.vue";
  import ContractorDocumentInfoProvider from "@/components/documents/ContractorDocumentInfoProvider.vue";

  @Component({
    components: {
      RemoveDocumentModal,
      ManagementDocumentInfoProvider,
      ContractorDocumentInfoProvider,
    },
  })
  export default class ConfirmRemovingDocumentModal extends Vue {
    @Prop({ type: Object, required: true }) readonly documents!: Document;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Boolean, default: false }) readonly attachedToInfoHidden!: boolean;

    modalShown: boolean = false;

    get isContractor(): boolean {
      return this.currentUser.role === Roles.CONTRACTOR;
    }

    onConfirm(): void {
      this.hideModal();
      this.$emit('confirmed');
    }

    showModal(): void {
      this.modalShown = true;
    }

    hideModal(): void {
      this.$emit('close');
    }
  }
